import store from "../../../store";
import report_doc_xls from "./report_doc_xls.vue";

window.REPORT_DOC_XLS =  new Vue({
    store,
    name : "REPORT_DOC_XLS",
    el: '#report_doc_xls',

    data () {
        return {
            showModal: false,
        }
    },
    created () {

    },

    components : {
        report_doc_xls
    }
});
